/**
 * SelectionAllocation component module.
 * @module advisor/components/benchmarks/SelectionAllocation
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown, NumberInput, Row} from '../../../shared';

// ETODO consider totally revising this component to be more generic if ever needed
/**
 * SelectionAllocation component
 * @name SelectionAllocation
 */
const SelectionAllocation = props => {
  const {title = [], dataPoint, options, onChange, readOnly} = props;

  const onSubInputChange = (name, value) => {
    let newData;

    newData = dataPoint.value;

    if (name === 'security') {
      newData.securityBenchmarkName = value.label;
      newData.securityID = value.value;
    } else {
      newData[name] = value;
    }

    onChange(dataPoint.name, newData);
  };

  const securityID = dataPoint.value && dataPoint.value.securityID;

  return <Row>
    <Dropdown width={'150px'}
              layout={{grow: 1}}
              title={title[0]}
              placeholder={'Select a Benchmark'}
              dataPoint={{
                name: 'security',
                value: securityID ? {label: dataPoint.value.securityBenchmarkName, value: securityID} : null,
              }}
              options={options}
              isSearchable={true}
              readOnly={readOnly}
              onChange={onSubInputChange}
    />
    <NumberInput type={'percent'}
                 decimalPlaces={0}
                 width={'50px'}
                 title={title[1]}
                 placeholder={'%'}
                 dataPoint={{name: 'weighting', value: dataPoint.value && dataPoint.value.weighting}}
                 validation={{min: 0.01, max: 1}}
                 readOnly={readOnly}
                 onBlur={onSubInputChange}
    />
  </Row>;
};

SelectionAllocation.propTypes = {
  /**
   * Title for the dropdown and number input, respectively.
   */
  title: PropTypes.arrayOf(PropTypes.string),
  /**
   * Selection Allocation data. Currently, this is specifically based on benchmark securities.
   */
  dataPoint: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.shape({
      /**
       * Security benchmark name, used for benchmarks dropdown option labels.
       */
      securityBenchmarkName: PropTypes.string,
      /**
       * Security ID, used for benchmarks dropdown option values.
       */
      securityID: PropTypes.number,
      /**
       * Security weighting (decimal), used for allocations number input value.
       */
      weighting: PropTypes.number,
    }),
  }).isRequired,
  /**
   * Set of options to pass to the dropdown. Should be an array of objects, each object with label, subLabel (optional), and value properties.
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    subLabel: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    value: PropTypes.isRequired,
    isDisabled: PropTypes.bool,
  })).isRequired,
  /**
   * The onChange function from Parent for the input field, required if not readOnly
   */
  onChange: (props, propName, componentName) => {
    PropTypes.checkPropTypes({[propName]: PropTypes.func}, props, propName, componentName);
    if (props.onChange || props.readOnly) {
      return null;
    }
    return new Error(`If ${componentName} is not readOnly then prop ${propName} is required.`);
  },
  /**
   * Whether the input is read-only
   */
  readOnly: PropTypes.bool,
};

export default SelectionAllocation;
